module.exports = __webpack_public_path__ + "img/arrow_right_green.dab29d9c.svg";